import { canNavigateHistoryBack, peekPreviousPath } from "./navigationMemory";

/**
 * @param {{ pathname?: string, search?: string, hash?: string } | null | undefined} from
 * @returns {string | null}
 */
export function pathFromLocationState(from) {
  if (!from || typeof from.pathname !== "string") return null;
  return `${from.pathname}${from.search || ""}${from.hash || ""}`;
}

/**
 * @param {{ pathname: string, search?: string, hash?: string, state?: { from?: unknown } }} location
 * @param {string} fallbackPath
 * @returns {{ mode: "history" | "fallback" | "explicit"; target: string }}
 */
export function resolveSmartBackDecision(location, fallbackPath = "/") {
  const current = `${location.pathname}${location.search || ""}${location.hash || ""}`;
  const fromTarget = pathFromLocationState(location.state?.from);
  const previous = peekPreviousPath();
  const fallback = fallbackPath || "/";

  if (fromTarget && fromTarget !== current) {
    if (previous === fromTarget && canNavigateHistoryBack()) {
      return { mode: "history", target: previous };
    }
    return { mode: "explicit", target: fromTarget };
  }

  if (previous && previous !== current && canNavigateHistoryBack()) {
    return { mode: "history", target: previous };
  }

  return { mode: "fallback", target: fallback };
}
